<template>
  <div class="list-group">
    <div v-for="order in displayedOrders" :key="order.id" class="list-group-item">
      <router-link :to="{name: 'orderDetail', params: {id: order.id}}">{{ order.number }}</router-link>
      {{ order.description }}
      <div v-if="order.reservation">
        {{ order.reservation.startTime | dateTime }}
      </div>
      <order-state :order="order"></order-state>
    </div>
  </div>
</template>

<script>
import {describe} from "@/utils/order-utils";
import OrderState from "@/components/order/OrderState";

export default {
  components: {OrderState},
  props: {
    orders: Array
  },
  computed: {
    displayedOrders() {
      return this.orders.map(o => {
        return {...o, description: describe(o)}
      })
    }
  }
}
</script>
